import { Dividend, Operation, Partner } from 'types';

export const getPartnersFromOldDividend = (
  operation: Operation | undefined
): Partner[] => {
  if (!operation?.dividends?.length) return [];

  return (operation.dividends as Dividend[])
    .map((dividend) => dividend.partner)
    .filter((partner): partner is Partner => !!partner);
};
